import { useState } from "react";

// Inline SVG Icons (most reliable)
import { FacebookIcon, XIcon, InstagramIcon } from "./SocialIcons";

import { ReactComponent as CopyIcon } from "../../icons/CopyIcon.svg";


export const InviteModalContent: React.FC<{ uid: string }> = (props) => {
    const [copied, setCopied] = useState(false);
    const [instagramCopied, setInstagramCopied] = useState(false);
    // TODO: create share id for each user
    const inviteLink = `https://www.${window.location.href.split("/")[2]}?sid=${props.uid}`;
  
    const handleCopy = () => {
      navigator.clipboard.writeText(inviteLink);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    };

    const handleFacebookShare = () => {
      const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(inviteLink)}`;
      window.open(facebookUrl, '_blank', 'width=600,height=400');
    };

    const handleXShare = () => {
      const xUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(inviteLink)}&text=${encodeURIComponent('Join me on HomeCook! Use my invite link:')}`;
      window.open(xUrl, '_blank', 'width=600,height=400');
    };

    const handleInstagramShare = () => {
      // Instagram doesn't have a direct web sharing API, so we'll copy the link to clipboard
      // and show a message to the user
      navigator.clipboard.writeText(inviteLink);
      setInstagramCopied(true);
      setTimeout(() => setInstagramCopied(false), 3000);
    };
  
    return (
      <div className="w-full max-w-lg flex flex-col items-center mb-6">
        <h2 className="text-[20px] font-bold text-black mb-2 w-full text-left font-raleway">Invite a Friend</h2>
        <div className="flex w-full items-center bg-white border border-gray-200 rounded-lg p-2 mb-4">
          <input
            className="flex-1 bg-transparent outline-none text-gray-700 text-sm border-0"
            value={inviteLink}
            readOnly
          />
          <button
            className="flex items-center ml-2 px-2 py-1 rounded font-open-sans hover:bg-gray-100 transition text-[#4D4D4D]/70 text-[16px] border-0"
            onClick={handleCopy}
            type="button"
          >
            {/* <img src={InviteIcon} alt="Copy Link" className="w-5 h-5 mr-1" /> */}
            <CopyIcon className="w-5 h-5 mr-1 text-black" />
            <span className="text-[16px] font-medium font-raleway text-[#4D4D4D]/70">{copied ? 'Copied!' : 'Copy Link'}</span>
          </button>
        </div>
        {/* <p className="text-primaryDark-200 text-[14px] font-medium font-open-sans my-2">Invite a friend to join and earn $10 for each successful referral.</p> */}
        <div className="text-[#808080]/50 text-[16px] font-semibold mb-3 font-raleway">Or Share On</div>
        
        {/* Instagram copy success message */}
        {instagramCopied && (
          <div className="w-full mb-3 p-3 bg-green-50 border border-green-200 rounded-lg">
            <div className="flex items-center">
              <div className="flex-shrink-0">
                <svg className="w-5 h-5 text-green-400" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
              </div>
              <div className="ml-3">
                <p className="text-sm font-medium text-green-800">
                  Link copied! Open Instagram and paste it in your story or post.
                </p>
              </div>
            </div>
          </div>
        )}
        
        <div className="flex flex-row gap-6">
          <div 
            className="rounded-full cursor-pointer bg-white border-[1px] border-[#E9E9E9]/90 w-10 h-10 flex items-center justify-center text-xl text-[#1877F2] hover:bg-blue-50 transition"
            onClick={handleFacebookShare}
            title="Share on Facebook"
          >
            <FacebookIcon className="w-5 h-5" />
          </div>
          <div 
            className="rounded-full cursor-pointer bg-white border-[1px] border-[#E9E9E9]/90 w-10 h-10 flex items-center justify-center text-xl text-black hover:bg-gray-100 transition"
            onClick={handleXShare}
            title="Share on X (Twitter)"
          >
            <XIcon className="w-5 h-5" />
          </div>
          <div 
            className={`rounded-full cursor-pointer bg-white border-[1px] border-[#E9E9E9]/90 w-10 h-10 flex items-center justify-center text-xl transition ${
              instagramCopied 
                ? 'bg-green-50 border-green-300 text-green-600' 
                : 'text-[#E4405F] hover:bg-pink-50'
            }`}
            onClick={handleInstagramShare}
            title="Copy link for Instagram"
          >
            <InstagramIcon className="w-5 h-5" />
          </div>
        </div>
      </div>
    );
  }
  